<template>
  <div class="home">
    <div class="flex-grid">
      <div class="grid-title">
        <h1>Configuración de la cuenta</h1>
      </div>
      <div class="card">
        <user-settings-form/>
      </div>
    </div>
  </div>
</template>

<script>
import UserSettingsForm from '@/components/UserSettingsForm.vue'
import axios from 'axios'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

export default {
  components: {
    'user-settings-form': UserSettingsForm
  },
}
</script>
